module.exports = __webpack_public_path__ + "static/media/close.6da599f2.svg";